import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import { customStyles } from "../Utility/Utility";
import { AddUpdate, getPostData,decrypt } from "../../../ApiMethods/ApiMethods";
import { encrypt } from "../../../store/actions/CommanAction";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import swal from "sweetalert";

const ServiceProvider = () => {
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    ServiceName: "" ,
    ServiceType: "",
    ProviderName: "",
    LoginBy: "email",
    AccountEmail: "",
    AccountMobileNo: "",
    Logindetail: "",
    APIKey: "",
    APItoken: "",
    APIURL: "",
    RenewalDate: "",
    Cost: 0,
    PaymentCycle: "",
    Notes: "",
    Status: "Active",
    ServiceID: null,
    
  });

  const fetchData = async () => {
    try {
      const val = { Status: "", RenewalDateFrom: "", RenewalDateTo: "" };
      const res = await getPostData(
        "ServiceProviders/GetData_ServiceProviders",
        val
      );

      setData(res);
    
    } catch (error) {
      console.error("Error fetching service providers:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const resetForm = () => {
    setFormData({
      ServiceName: "",
      ServiceType: "",
      ProviderName: "",
      LoginBy: "email",
      AccountEmail: "",
      AccountMobileNo: "",
      Logindetail: "",
      APIKey: "",
      APItoken: "",
      APIURL: "",
      RenewalDate: "",
      Cost: "",
      PaymentCycle: "",
      Notes: "",
      Status: "Active",
      ServiceID: null,
    });
    setEditMode(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "LoginBy") {
      setFormData((prev) => ({
        ...prev,
        LoginBy: value,
        AccountEmail: value === "email" ? prev.AccountEmail : "",
        AccountMobileNo: value === "mobileno" ? prev.AccountMobileNo : "",
      
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  let error = false;
  let errormsg = "";

  if (!formData.ServiceName) {
    error = true;
    errormsg = "Please fill required Service Name";
  } 
  else if (!formData.Cost) {
    error = true;
    errormsg = "Please fill required Cost";
  }

  if (!error) {
    try {
      const encryptedPayload = {
        ...formData,
        APIKey: encrypt(JSON.stringify(formData.APIKey)),
        APIURL: encrypt(JSON.stringify(formData.APIURL)),
        APItoken: encrypt(JSON.stringify(formData.APItoken)),
        Logindetail: encrypt(JSON.stringify(formData.Logindetail)),
      };

      if (editMode) {
        await AddUpdate(`ServiceProviders/Update_ServiceProviders`, encryptedPayload);
      } else {
        await AddUpdate(`ServiceProviders/Insert_ServiceProviders`, encryptedPayload);
      }

      fetchData();
      setModalOpen(false);
      resetForm();
    } catch (error) {
      console.error("Error saving data:", error);
    }
  } else {
    swal("Oops", errormsg, "error");
  }
};


useEffect(() => {
  if (editMode && formData) {
    setFormData({
      ...formData,
      RenewalDate: formData.RenewalDate ? formData.RenewalDate.split("T")[0] : "",
    });
  }
}, [editMode, formData]);


  const handleEdit = async (row) => {
   
    const id=row.ServiceID;
    try {
      const res = await AddUpdate(
        "ServiceProviders/GetSingleData_ServiceProviders",
       {
  ServiceID: id,
}
      );

if (res.data) {
  const datas = JSON.parse(res?.data?.data);
  const finaldata = datas?.Table;

  if (finaldata?.length > 0) {
    const firstRow = finaldata[0];



    
    const decryptedData = {
      ...firstRow,
      APIKey: firstRow.APIKey ? decrypt(firstRow.APIKey).replace(/^"|"$/g, "") : "",
      APIURL: firstRow.APIURL ? decrypt(firstRow.APIURL).replace(/^"|"$/g, "") : "",
      APItoken: firstRow.APItoken ? decrypt(firstRow.APItoken).replace(/^"|"$/g, "") : "",
      Logindetail: firstRow.Logindetail ? decrypt(firstRow.Logindetail).replace(/^"|"$/g, "") : "",
    };



    setFormData(decryptedData);
  }

  setEditMode(true);
  setModalOpen(true);
}

    } catch (error) {
      console.error("Error fetching single service provider:", error);
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await AddUpdate(`ServiceProviders/Delete_ServiceProviders`, {
        ServiceID: row.ServiceID,
      });
      fetchData();
    } catch (error) {
      console.error("Error deleting service provider:", error);
    }
  };

  const columns = [
    {
      name: "Service Name",
      selector: (row) => row.ServiceName,
      sortable: true,
    },
    { name: "Service Type", selector: (row) => row.ServiceType },
    { name: "Provider", selector: (row) => row.ProviderName },
    { name: "Login By", selector: (row) => row.LoginBy },
    { name: "Email", selector: (row) => row.AccountEmail },
    { name: "Mobile", selector: (row) => row.AccountMobileNo },
 {
  name: "Renewal Date",
  selector: (row) => row.RenewalDate ? row.RenewalDate.split("T")[0] : "-",
},

    { name: "Cost", selector: (row) => row.Cost },
    { name: "Status", selector: (row) => row.Status },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button style={{backgroundColor:"#03a9fc",color:"black"}}
            className="btn btn-sm btn-warning me-2"
            onClick={() => handleEdit(row)}
          >
           <FaRegEdit />
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row)}
          >
           <MdDelete />
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="container mt-1">
      <h2 style={{ color: "#f7931e", fontWeight: 700 }}> Service Providers</h2>
      <div>
        {" "}
        <button
          className="btn btn-primary font-w600 mb-2"
          onClick={() => {
            resetForm();
            setModalOpen(true);
          }}
        >
          Add Service Provider
        </button>
      </div>


      <div className="row">
         <div className="col-12 mt-2">
      <DataTable
        dense
        data={data}
        columns={columns}
        selectableRowsHighlight
        pagination
        fixedHeader
        persistTableHead={true}
        noDataComponent={"There are no data to display"}
        customStyles={customStyles}
      />
</div>
</div>
    

{modalOpen && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div className="modal-content shadow-lg rounded-3">
        <div className="modal-header border-bottom-0">
          <h5 className="modal-title fw-bold">
            {editMode ? "Edit Service Provider" : "Add Service Provider"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setModalOpen(false);
              resetForm();
            }}
          ></button>
        </div>

        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">Service Name<span className="text-danger star-error" >*</span></label>
                <input
                  type="text"
                  name="ServiceName"
                  value={formData.ServiceName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter service name"
                  
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Service Type</label>
                <input
                  type="text"
                  name="ServiceType"
                  value={formData.ServiceType}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter service type"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Provider Name</label>
                <input
                  type="text"
                  name="ProviderName"
                  value={formData.ProviderName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter provider name"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Login By</label>
                <select
                  name="LoginBy"
                  value={formData.LoginBy}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="email">Email</option>
                  <option value="mobileno">Mobile No</option>
                </select>
              </div>

              {formData.LoginBy === "email" && (
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Account Email</label>
                  <input
                    type="email"
                    name="AccountEmail"
                    value={formData.AccountEmail}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter account email"
                  />
                </div>
              )}

              {formData.LoginBy === "mobileno" && (
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Account Mobile No</label>
                  <input
                    type="text"
                    name="AccountMobileNo"
                    value={formData.AccountMobileNo}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter mobile number"
                  />
                </div>
              )}

              <div className="col-md-6">
                <label className="form-label fw-semibold">Login Detail</label>
                <input
                  type="text"
                  name="Logindetail"
                  value={formData.Logindetail}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter login detail"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">API Key</label>
                <input
                  type="text"
                  name="APIKey"
                  value={formData.APIKey}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter API key"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">API Token</label>
                <textarea
                  name="APItoken"
                  value={formData.APItoken}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter API token"
                  rows={2}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">API URL</label>
                <input
                  type="text"
                  name="APIURL"
                  value={formData.APIURL}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter API URL"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Renewal Date</label>
                <input
                  type="date"
                  name="RenewalDate"
                  value={formData.RenewalDate}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Cost<span className="text-danger star-error" >*</span></label>
                <input
                  type="number"
                  name="Cost"
                  value={formData.Cost}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter cost"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Payment Cycle</label>
                <input
                  type="text"
                  name="PaymentCycle"
                  value={formData.PaymentCycle}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter payment cycle"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Notes</label>
                <textarea
                  name="Notes"
                  value={formData.Notes}
                  onChange={handleChange}
                  className="form-control"
                  rows={2}
                  placeholder="Enter notes"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Status</label>
                <select
                  name="Status"
                  value={formData.Status}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="Active">Active</option>
                  <option value="Expired">Expired</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>
            </div>

            <div className="text-end mt-4">
              <button type="submit" className="btn btn-primary px-4 py-2 fw-semibold">
                {editMode ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default ServiceProvider;
